import axios from 'axios';
import { useToast } from 'vue-toastification';
import { useCompanyStore } from '@/store/company.store';

const toast = useToast();
const baseURL = process.env.VUE_APP_API_URL || 'http://localhost:9000';

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    const companyStore = useCompanyStore();
    
    if (token) {
      config.headers['Authorization'] = `${token}`;
      config.headers['Retail-Token'] = localStorage.getItem('retail_token');
    }
    
    if (companyStore.selectedCompanyId) {
      config.headers['X-Company-ID'] = companyStore.selectedCompanyId;
    }
    
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    console.error('Response Error Details:', {
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers
    });
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      toast.error('Session expired. Please login again.');
      window.location.href = '/login';
    } else {
      // toast.error(error.response?.data?.message || 'An error occurred');
    }
    return Promise.reject(error);
  }
);